module.exports = __webpack_public_path__ + "static/media/savio19.8389ddb2.jpg";